import styled from 'styled-components';

const isDefined = val => {
    return val !== 'undefined';
};

const PositionedDiv = styled.div`
    ${ props => {
        const { top, left, mobileTop, mobileLeft, width, mobileWidth, height } = props;
        let style = '';

        if (width && mobileWidth) {
            style += `
                width: ${ mobileWidth };

                @media (min-width: 1024px) {
                    width: ${ width };
                }
            `;
        } else if (width) {
            style += `
                width: ${ width }; 
            `;
        }

        if (height) {
            style += `
                @media (min-width: 1024px) {
                    max-height: ${ height };
                }
            `;
        }

        if (mobileTop && mobileLeft) {
            style += `
                top: ${ mobileTop };
                left: ${ mobileLeft };

                @media (min-width: 1024px) {
                    top: ${ top };
                    left: ${ left };            
                }
            `;
        } else {
            style += `
                top: ${ top };
                left: ${ left };
            `;
        }

        return style;
    }
}`;

export default PositionedDiv;
